import App from '@/models/App'

export default class TrafficShipFormFormat extends App {
    static get entity() {
        return 'TrafficShipFormFormats'
    }

    static all() {
        return this.query().withAllRecursive().where('isDeleted', false).get()
    }

    static findById(id) {
        return this.query().whereId(id).withAllRecursive().first()
    }

    static fields() {
        return {
            id: this.attr(''),
            organizationId: this.attr(''),
            name: this.attr(''),
            isLock: this.attr(''),
            isDeleted: this.attr(''),
            sortNum: this.attr(''),
            trafficShipFormItems: this.attr([]),
        }
    }

    static apiConfig = {
        actions: {
            fetch() {
                return this.get(`traffic/ship/form/formats`, {
                    params: { all: true },
                    headers: {
                        Authorization: 'Bearer ' + App.apiToken(),
                        'Accept-Language': App.acceptLanguage(),
                    },
                    dataKey: 'data',
                    baseURL: App.apiURL(),
                })
            },
            create(params) {
                return this.post(
                    `traffic/ship/form/formats`,
                    App.post(params),
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        baseURL: App.apiURL(),
                    }
                )
            },
            update(trafficShipFormFormatId, params) {
                return this.patch(
                    `traffic/ship/form/formats/${trafficShipFormFormatId}`,
                    App.patch(params),
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        baseURL: App.apiURL(),
                    }
                )
            },
            destroy(trafficShipFormFormatId) {
                return this.delete(
                    `traffic/ship/form/formats/${trafficShipFormFormatId}`,
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        baseURL: App.apiURL(),
                    }
                )
            },
        },
    }
}
